export const POLYMAILER_DISTANCE_IN = 'in';
export const POLYMAILER_DISTANCE_CM = 'cm';
export const POLYMAILER_DISTANCE_MM = 'mm';
export const POLYMAILER_DISTANCE_MM_VALUE = 6.35;
export const POLYMAILER_DISTANCE_CM_VALUE = 0.635;
export const POLYMAILER_DISTANCE_IN_VALUE = 0.25;
